module.exports = __webpack_public_path__ + "static/media/G1-R1-Recurso-codR2.b804f638.png";